import { MsalProvider } from '@azure/msal-react';
import { CssBaseline } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { msalClient } from 'application';
import AccessDialog from 'components/AccessDialog';
import { IntlProvider } from 'contexts/intl';
import { MessagesProvider } from 'contexts/message';
import { SessionProvider } from 'contexts/session';
import { SnackbarProvider } from 'contexts/snackbar';
import { ThemeProvider } from 'contexts/theme';
import { createContext, useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import { browserRouter } from 'router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export const AppContext = createContext<{
  isAccessRequestOpen: boolean;
  setIsAccessRequestOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}>({ isAccessRequestOpen: false });

function App() {
  const [isAccessRequestOpen, setIsAccessRequestOpen] = useState(false);

  return (
    <MsalProvider instance={msalClient}>
      <SessionProvider>
        <IntlProvider>
          <QueryClientProvider client={queryClient}>
            <ThemeProvider>
              <CssBaseline />
              <MessagesProvider>
                <SnackbarProvider>
                  <AppContext.Provider
                    value={{
                      isAccessRequestOpen,
                      setIsAccessRequestOpen,
                    }}
                  >
                    <RouterProvider router={browserRouter} />
                    <AccessDialog />
                  </AppContext.Provider>
                </SnackbarProvider>
              </MessagesProvider>
            </ThemeProvider>
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </IntlProvider>
      </SessionProvider>
    </MsalProvider>
  );
}

export default App;
